import axios from "axios";
import Alert from "react-s-alert";
import { amApi } from "../../../api/apiHelper";
import { serverApi } from "../../../config/Keys";
import {
  SET_LOADER_SECONDARY,
  CLEAR_ERRORS,
  CLEAR_LOADER,
  EDITUSER_DATA_STEP1,
  EDITUSER_DATA_STEP1_HOME,
  EDITUSER_DATA_STEP2,
  EDITUSER_DATA_STEP2_HOME,
  EDITUSER_DATA_STEP3,
  EDITUSER_DATA_STEP3_HOME,
  EDITUSER_DATA_STEP4,
  EDITUSER_DATA_STEP4_HOME,
  SET_LOADER,
  SUPERADMIN_ADD_COMMENT_ISSUE,
  SUPERADMIN_ALL_USER_LIST,
  SUPERADMIN_CHANGE_STATUS_ISSUE_DETAIL,
  SUPERADMIN_USER_ALL_DETAILS,
  SUPERADMIN_USER_DETAILS_DATE_RANGE,
  SA_USER_DETAILS_SEATING,
  SA_USER_DETAILS_ORDERING,
  SA_USER_DETAILS_EVENTS,
  SA_USER_DETAILS_FAVOURITES,
  SA_USER_DETAILS_LIVE_STREAMING,
  SA_USER_DETAILS_MISCELLANEOUS,
  SA_USER_DETAILS_NOMINATIONS,
  SA_USER_DETAILS_OFFERS,
  SA_USER_DETAILS_EXPERIENCE,
  SA_USER_DETAILS_REFERRAL,
  SA_USER_DETAILS_REVIEWS,
  SA_USER_DETAILS_USER_TICKETS,
  SA_USER_DETAILS_VIDEO_CONTENT,
  SA_USER_DETAILS_WALLET,
  SUPERADMIN_USER_BLOCK,
  SUPERADMIN_USER_BLOCK_HOME,
  SUPERADMIN_USER_DELETE,
  SUPERADMIN_USER_FLAG,
  SUPERADMIN_USER_FLAG_HOME,
  SUPERADMIN_USER_ISSUES_LIST,
  SUPERADMIN_USER_ISSUE_DETAIL,
  SUPERADMIN_USER_ARCHIVE_HOME,
  SUPERADMIN_USER_ARCHIVE,
  SUPERADMIN_ALL_USER_STATS,
  SA_USER_DETAILS_REELS,
} from "../../types";
import { setErrors } from "../errorActions";

/***************************************
 * @DESC - SEND NOTIFICATION ACTION
 *****************************************/
export const add_admin_category_icon = (formData) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let add_admin_category_icon = await axios.post(
      `${serverApi}/subcategory`,
      formData
    );
    if (add_admin_category_icon.status === 201) {
      dispatch({ type: CLEAR_LOADER });
      Alert.success(`<h4>Category Add Successfully</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

// add new user from admin

export const addNewUser =
  (formData, token, onSuccessAdd) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let add_admin_new_user = await axios.post(
        `${serverApi}/admin/user-service`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_admin_new_user.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>User Added Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccessAdd();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

//check if email ,mobile exists

export const checkIfEmailExists =
  (formData, onSuccessEmailStatus) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let email_status = await axios.post(
        `${serverApi}/admin/user-validation`,
        formData
      );
      if (email_status.status === 201) {
        dispatch({ type: CLEAR_LOADER });
      }
      onSuccessEmailStatus(email_status.data);
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

// check if phone exists

export const checkIfPhoneExists =
  (formData, onSuccessPhoneStatus) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let phone_status = await axios.post(
        `${serverApi}/admin/user-validation`,
        formData
      );
      if (phone_status.status === 201) {
        dispatch({ type: CLEAR_LOADER });
      }
      onSuccessPhoneStatus(phone_status.data);
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

// get cruisnes

export const getCrusines =
  (onSuccessGetCrusines, onErrorGetCruisnes) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_crusines = await axios.get(
        `${serverApi}/subcategory?category_id=5f562c9094ac7fdf47ea1d1e`
      );
      if (get_crusines.status === 201) {
        dispatch({ type: CLEAR_LOADER });
      }
      dispatch({ type: CLEAR_LOADER });
      onSuccessGetCrusines(get_crusines.data);
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const getFavPlaces =
  (onSuccessGetFavPlaces, onErrorGetFavPlaces) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_fav_places = await axios.get(
        `${serverApi}/subcategory?category_id=5f562c9094ac7fdf47ea1d0a`
      );
      if (get_fav_places.status === 201) {
        dispatch({ type: CLEAR_LOADER });
      }
      onSuccessGetFavPlaces(get_fav_places.data);
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      //onErrorGetFavPlaces();
    }
  };

export const getFavChains =
  (onSuccessGetFavChain, onErrorGetFavChain) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_fav_chains = await axios.get(
        `${serverApi}/restaurantchain?status=APPROVED`
      );
      if (get_fav_chains.status === 200) {
        dispatch({ type: CLEAR_LOADER });
      }
      dispatch({ type: CLEAR_LOADER });
      onSuccessGetFavChain(get_fav_chains.data.data);
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

//get dietary pref

export const getDietaryPref =
  (onSuccessGetDietaryPref, onErrorGetDietaryPref) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_dietary_pref = await axios.get(
        `${serverApi}/subcategory?category_id=5f59f4bc471b85440d5adcc6`
      );
      if (get_dietary_pref.status === 200) {
        dispatch({ type: CLEAR_LOADER });
      }
      onSuccessGetDietaryPref(get_dietary_pref.data);
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

//get allerg

export const getAllergies =
  (onSuccessAllergies, onErrorGetAllergies) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_allergies = await axios.get(
        `${serverApi}/subcategory?category_id=5f59f5d4471b85440d5adccc`
      );
      if (get_allergies.status === 200) {
        dispatch({ type: CLEAR_LOADER });
      }
      onSuccessAllergies(get_allergies.data);
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

// get all category

export const getAllCateogryForIcons =
  (onSuccessGetFavChain) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let get_all_category_for_icons = await axios.get(`${serverApi}/category`);
      if (get_all_category_for_icons.status === 201) {
        dispatch({ type: CLEAR_LOADER });
      }
      onSuccessGetFavChain(get_all_category_for_icons.data);
      dispatch({ type: CLEAR_LOADER });
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

//get sub category

export const getSubCateogryWithCategoryId =
  (onSuccessGetSubCategory, categoryId) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let get_sub_category = await axios.get(
        `${serverApi}/subcategory?category_id=${categoryId}`
      );
      if (get_sub_category.status === 201) {
        dispatch({ type: CLEAR_LOADER });
      }
      onSuccessGetSubCategory(get_sub_category.data);
      dispatch({ type: CLEAR_LOADER });
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const addNewSubCategoryFromCategory =
  (formData, token, onSuccessAddSubCategory, onErrorAddSubCateogry) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      try {
        let add_admin_new_user = await axios.post(
          `${serverApi}/subcategory`,
          formData,
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
          }
        );
        if (add_admin_new_user.status === 201) {
          dispatch({ type: CLEAR_LOADER });

          Alert.success(`<h4>Sub Category Added Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
          onSuccessAddSubCategory();
        }
      } catch (err) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
        Alert.error(`<h4>${err}</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onErrorAddSubCateogry(err);
      }
    };

export const deleteSubCategoryFromCategory =
  (id, token, onSuccessDeleteSubCategory, onErrorDeleteSubCateogry) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      try {
        let edit_sub_category = await axios.delete(
          `${serverApi}/subcategory?id=${id}`,

          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
          }
        );
        if (edit_sub_category.status === 200) {
          dispatch({ type: CLEAR_LOADER });

          Alert.success(`<h4>Sub category deleted successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
          onSuccessDeleteSubCategory();
        } else {
          onErrorDeleteSubCateogry();
          Alert.error(`<h4> Something went wrong</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        }
      } catch (err) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
        Alert.error(`<h4>${err}</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    };

export const editSubCategoryFromCategory =
  (id, formData, token, onSuccessEditSubCategory, onErrorEditSubCateogry) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      try {
        let edit_sub_category = await axios.patch(
          `${serverApi}/subcategory?id=${id}`,
          formData,
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
          }
        );
        if (edit_sub_category.status === 200) {
          dispatch({ type: CLEAR_LOADER });

          Alert.success(`<h4>Sub Category Updated Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
          onSuccessEditSubCategory();
        }
      } catch (err) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
        Alert.error(`<h4>${err}</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onErrorEditSubCateogry(err);
      }
    };

export const getUserDetailsFromUserId =
  (userId, onSuccessLoadData) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_sub_category = await axios.get(
        `${serverApi}/admin/user-service/${userId}`
      );
      if (get_sub_category.status === 200) {
        dispatch({
          type: SUPERADMIN_USER_ALL_DETAILS,
          payload: get_sub_category.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
      onSuccessLoadData(get_sub_category.data);
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const getUserDetailsDateRange =
  (data) => async (dispatch) => {
    try {
      dispatch({
        type: SUPERADMIN_USER_DETAILS_DATE_RANGE,
        payload: data,
      });
    } catch (err) {
      dispatch(setErrors(err));
    }
  };

export const getUserDetailsByType =
  (userId, token, query, onSuccessLoadData) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_sub_category = await axios.get(
        `${serverApi}/admin/user-service/${userId}`,
        {
          params: query, headers: {
            Authorization: token,
            "Content-Type": "application/json",
          }
        }
      );
      if (get_sub_category.status === 200) {
        if (query.type === "SEATING") {
          dispatch({
            type: SA_USER_DETAILS_SEATING,
            payload: get_sub_category.data,
          });
        } else if (query.type === "ORDERING") {
          dispatch({
            type: SA_USER_DETAILS_ORDERING,
            payload: get_sub_category.data,
          });
        } else if (query.type === "EVENTS") {
          dispatch({
            type: SA_USER_DETAILS_EVENTS,
            payload: get_sub_category.data,
          });
        } else if (query.type === "WALLET") {
          dispatch({
            type: SA_USER_DETAILS_WALLET,
            payload: get_sub_category.data,
          });
        } else if (query.type === "NOMINATIONS") {
          dispatch({
            type: SA_USER_DETAILS_NOMINATIONS,
            payload: get_sub_category.data,
          });
        } else if (query.type === "FAVOURITES") {
          dispatch({
            type: SA_USER_DETAILS_FAVOURITES,
            payload: get_sub_category.data,
          });
        } else if (query.type === "REVIEWS") {
          dispatch({
            type: SA_USER_DETAILS_REVIEWS,
            payload: get_sub_category.data,
          });
        } else if (query.type === "REFERRAL") {
          dispatch({
            type: SA_USER_DETAILS_REFERRAL,
            payload: get_sub_category.data,
          });
        } else if (query.type === "MISCELLANEOUS") {
          dispatch({
            type: SA_USER_DETAILS_MISCELLANEOUS,
            payload: get_sub_category.data,
          });
        } else if (query.type === "USER_TICKETS") {
          dispatch({
            type: SA_USER_DETAILS_USER_TICKETS,
            payload: get_sub_category.data,
          });
        } else if (query.type === "LIVE_STREAMING") {
          dispatch({
            type: SA_USER_DETAILS_LIVE_STREAMING,
            payload: get_sub_category.data,
          });
        } else if (query.type === "VIDEO_CONTENT") {
          dispatch({
            type: SA_USER_DETAILS_VIDEO_CONTENT,
            payload: get_sub_category.data,
          });
        } else if (query.type === "OFFERS") {
          dispatch({
            type: SA_USER_DETAILS_OFFERS,
            payload: get_sub_category.data,
          });
        }else if (query.type === "EXPERIENCE") {
          dispatch({
            type: SA_USER_DETAILS_EXPERIENCE,
            payload: get_sub_category.data,
          });
        }else if (query.type === "SHORT_VIDEOS") {
          dispatch({
            type: SA_USER_DETAILS_REELS,
            payload: get_sub_category.data,
          })
        }
        dispatch({ type: CLEAR_LOADER });
      }
      onSuccessLoadData(get_sub_category.data);
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };


export const editStep1 =
  (userId, formData, onSuccessUpdate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let add_admin_category_icon = await axios.patch(
        `${serverApi}/admin/user-service/${userId}`,
        formData
      );
      if (add_admin_category_icon.status === 200) {
        formData._id = userId;
        formData.updatedAt = add_admin_category_icon.data.updatedAt;
        dispatch({ type: EDITUSER_DATA_STEP1, payload: formData });
        dispatch({ type: EDITUSER_DATA_STEP1_HOME, payload: formData });
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Updated Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
      onSuccessUpdate();
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const editStep2 =
  (userId, formData, onSuccessUpdate, inputFields) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let edit_step_2 = await axios.patch(
        `${serverApi}/admin/user-service/${userId}`,
        formData
      );
      if (edit_step_2.status === 200) {
        inputFields._id = userId;
        inputFields.updatedAt = edit_step_2.data.updatedAt;
        dispatch({ type: EDITUSER_DATA_STEP2, payload: inputFields });
        dispatch({ type: EDITUSER_DATA_STEP2_HOME, payload: inputFields });
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Updated Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
      onSuccessUpdate();
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const editStep3 =
  (userId, formData, onSuccessUpdate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let add_admin_category_icon = await axios.patch(
        `${serverApi}/admin/user-service/${userId}`,
        formData
      );
      if (add_admin_category_icon.status === 200) {
        formData._id = userId;
        formData.updatedAt = add_admin_category_icon.data.updatedAt;
        dispatch({ type: EDITUSER_DATA_STEP3, payload: formData });
        dispatch({ type: EDITUSER_DATA_STEP3_HOME, payload: formData });
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Updated Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
      onSuccessUpdate();
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const editStep4 =
  (userId, formData, onSuccessUpdate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let add_admin_category_icon = await axios.patch(
        `${serverApi}/admin/user-service/${userId}`,
        formData
      );
      if (add_admin_category_icon.status === 200) {
        formData._id = userId;
        formData.updatedAt = add_admin_category_icon.data.updatedAt;
        dispatch({ type: EDITUSER_DATA_STEP4, payload: formData });
        dispatch({ type: EDITUSER_DATA_STEP4_HOME, payload: formData });
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Updated Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
      onSuccessUpdate();
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const deleteUserFromDetailPage =
  (userId, formData, onSuccessDelete) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let delete_user_detail_page = await axios.delete(
        `${serverApi}/admin/user-service/${userId}`
      );
      if (delete_user_detail_page.status === 200) {
        dispatch({ type: SUPERADMIN_USER_DELETE });
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>User Deleted Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
      onSuccessDelete();
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const blockUserFromDetailPage =
  (userId, formData, onSuccessBlock) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let block_user_detail_page = await axios.patch(
        `${serverApi}/admin/user-service/${userId}`,
        formData
      );
      if (block_user_detail_page.status === 200) {
        formData.userId = userId;
        onSuccessBlock();
        dispatch({
          type: SUPERADMIN_USER_BLOCK,
          payload: formData.user_blocked,
        });
        dispatch({ type: SUPERADMIN_USER_BLOCK_HOME, payload: formData });
        dispatch({ type: CLEAR_LOADER });
        Alert.success(
          `<h4>User ${formData.user_blocked ? "Blocked" : "Unblocked"
          } successfully</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const flagUserFromDetailPage =
  (userId, formData, onSuccessFlag, e) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let block_user_detail_page = await axios.patch(
        `${serverApi}/admin/user-service/${userId}`,
        formData
      );
      if (block_user_detail_page.status === 200) {
        formData.userId = userId;
        if (e === "ARCHIVE") {
          dispatch({ type: SUPERADMIN_USER_ARCHIVE, payload: formData.isArchive });
          dispatch({ type: SUPERADMIN_USER_ARCHIVE_HOME, payload: formData });
        } else {
          dispatch({ type: SUPERADMIN_USER_FLAG, payload: formData.isFlag });
          dispatch({ type: SUPERADMIN_USER_FLAG_HOME, payload: formData });
          Alert.success(
            `<h4>User ${formData.isFlag ? "Flagged" : "Unflagged"
            } successfully</h4>`,
            {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            }
          );
        }
        dispatch({ type: CLEAR_LOADER });
        onSuccessFlag();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const getAllUsersList =
  (search, searchByUserId, phoneNumberSearch, params, token, onSuccessLoadUsers) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      try {
        // let get_all_users = await axios.get(
        //   `${serverApi}/admin/user-service?search=${search}&id=${searchByUserId}&number=${phoneNumberSearch}`
        // );
        let get_all_users = await axios.get(`${serverApi}/admin/user-service`, {
          params: params,
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        });
        if (get_all_users.status === 200) {
          dispatch({ type: CLEAR_LOADER });
          dispatch({
            type: SUPERADMIN_ALL_USER_LIST,
            payload: get_all_users.data,
          });
        }
        onSuccessLoadUsers(get_all_users.data);
      } catch (err) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
      }
    };
export const getAllUsersStats =
  (params) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      try {
        let get_all_users = await amApi.get(`/admin/user-service`, {
          params: { ...params, stats: true }
        });
        if (get_all_users.status === 200) {
          dispatch({
            type: SUPERADMIN_ALL_USER_STATS,
            payload: get_all_users.data,
          });
        }
      } catch (err) {
        dispatch(setErrors(err));
      }
    };

/// get user tickets

export const getUserTickets =
  (status, startDate, endDate, onSuccessGetAllTickets) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      var get_all_user_tickets;
      if (status !== 4) {
        get_all_user_tickets = await axios.get(
          `${serverApi}/admin/ticket?status=${status}&startDate=${startDate}&endDate=${endDate}`
        );
      } else {
        get_all_user_tickets = await axios.get(`${serverApi}/admin/ticket`);
      }
      if (get_all_user_tickets.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SUPERADMIN_USER_ISSUES_LIST,
          payload: get_all_user_tickets.data,
        });
      }
      onSuccessGetAllTickets();
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - FILTER ACTION FOR PENDING VENDORS
 * *****************************************/
export const admin_get_user_tickets_filter =
  (token, status, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      const get_all_user_tickets = await axios.get(
        `${serverApi}/admin/ticket?status=${status}&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: { Authorization: token },
        }
      );
      if (get_all_user_tickets.status === 200) {
        dispatch({
          type: SUPERADMIN_USER_ISSUES_LIST,
          payload: get_all_user_tickets.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const updateTicketStatus =
  (
    token,
    formData,
    ticketId,
    onSuccessChangeTicketStatus,
    onErrorChangeTicketStatus,
    handleClose
  ) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });

      try {
        let change_ticket_status = await axios.patch(
          `${serverApi}/admin/ticket/${ticketId}`,
          formData,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        if (change_ticket_status.status === 200) {
          dispatch({
            type: SUPERADMIN_CHANGE_STATUS_ISSUE_DETAIL,
            payload: formData,
          });
          Alert.success(`<h4>Ticket updated successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
          formData.id = ticketId;
          onSuccessChangeTicketStatus(handleClose);
          dispatch({ type: CLEAR_LOADER });

          // dispatch({
          //   type: SUPERADMIN_UPDATE_TICKET_STATUS,
          //   payload: formData,
          // });
        } else {
          onErrorChangeTicketStatus();
        }
      } catch (err) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
      }
    };

export const getUserTicketDetailsFromIssueId =
  (issueId, token, onSuccessGetTicketDetail) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_user_issue_detail = await axios.get(
        `${serverApi}/admin/ticket/${issueId}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_user_issue_detail.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SUPERADMIN_USER_ISSUE_DETAIL,
          payload: get_user_issue_detail.data,
        });
      }
      onSuccessGetTicketDetail();
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const sendCommentForIssue =
  (token, issueId, formData, onSuccessGetTicketDetail) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let add_comment = await axios.patch(
        `${serverApi}/admin/ticket/${issueId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_comment.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SUPERADMIN_ADD_COMMENT_ISSUE,
          payload: add_comment.data,
        });
      }
      onSuccessGetTicketDetail();
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const getTicketsByUserMobileNo =
  (token, countryCode, mobileNo, onSuccessLoadUserData) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_diner_info = await axios.get(
        `${serverApi}/admin/ticket?country_code=${countryCode}&mobile_number=${mobileNo}`,

        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_diner_info.status === 200) {
        onSuccessLoadUserData(get_diner_info.data);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const addUserTicket =
  (token, formData, onSuccessAddTicket, onErrorAddTicket) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });

      try {
        let add_user_ticket = await axios.post(
          `${serverApi}/admin/ticket`,
          formData,

          {
            headers: {
              Authorization: token,
            },
          }
        );

        if (add_user_ticket.status === 201) {
          onSuccessAddTicket();
          dispatch({ type: CLEAR_LOADER });
          Alert.success(`<h4>Ticket Created Sucessfully </h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        }
      } catch (err) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
        onErrorAddTicket(err.response.data.message);
      }
    };

export const updateUserTicketData =
  (token, formData, ticketId, onSuccessEditTicket, onErrorEditTicket) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });

      try {
        let change_ticket_status = await axios.put(
          `${serverApi}/admin/ticket/${ticketId}`,
          formData,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        if (change_ticket_status.status === 200) {
          Alert.success(`<h4>Ticket updated successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });

          onSuccessEditTicket();
          dispatch({ type: CLEAR_LOADER });

          // dispatch({
          //   type: SUPERADMIN_UPDATE_TICKET_STATUS,
          //   payload: formData,
          // });
        }
      } catch (err) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
        onErrorEditTicket();
      }
    };

export const getAllCountries = (onSuccessGetCountries) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let get_all_countries = await axios.get(
      `${serverApi}/country-state-city?country=true`
    );
    if (get_all_countries.status === 200) {
      dispatch({ type: CLEAR_LOADER });
      onSuccessGetCountries(get_all_countries.data);
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const getAllStateFromCountry =
  (countryCode, onSuccessGetAllStates) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_all_states = await axios.get(
        `${serverApi}/country-state-city?state=true&country_id=${countryCode}`
      );
      if (get_all_states.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        onSuccessGetAllStates(get_all_states.data);
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const getAllCityFromState =
  (stateCode, onSuccessGetAllcity) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_all_cities = await axios.get(
        `${serverApi}/country-state-city?city=true&state_id=${stateCode}`
      );
      if (get_all_cities.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        onSuccessGetAllcity(get_all_cities.data);
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
